// Stimulus controller for notification bell dropdown (Issue #839, Epic #798)
// Handles toggling the notification dropdown and managing its state
// Uses Bootstrap's dropdown functionality with Stimulus for custom behavior
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Initialize Bootstrap dropdown if available
    // The dropdown behavior is primarily handled by Bootstrap's data-bs-toggle
    // This controller adds custom behavior like marking notifications as read
  }

  toggle(event) {
    // Bootstrap handles the dropdown toggle via data-bs-toggle="dropdown"
    // This method is here for any custom behavior we might want to add
    // such as tracking analytics or refreshing the notification count
  }

  // Mark notification as read when clicked
  markAsRead(event) {
    const notificationId = event.currentTarget.dataset.notificationId
    if (notificationId) {
      // The link already navigates to the show action which marks as read
      // This method is available for any additional client-side handling
    }
  }
}
